import request from '../utils/request';

/**
 * @description: 三包信息列表
 * @param {*} data 
 */
export function ShowSBInfo(data) {
  return request({
    url: '/CarOwnerApi/getCarInfoByVIdList',
    method: 'post',
    params:data
  })
}

/**
 * @description: 根据配件查详情
 * @param {*} data 
 */
 export function RepairHistory(data) {
  return request({
    url: '/CarOwnerApi/getCarInfoRepairHistory',
    method: 'post',
    data
  })
}